export default "__VITE_ASSET__mVXjTCFn__"